import { TFunction } from "i18next";
import { z } from "zod";

export const getPumpColumnFormSchema = (t: TFunction) => {
  return z.object({
    waterLevelGuardDepth: z.number().nullable().optional(),
    speedControl: z.string().nullable().optional(),
    piezometricTubeType: z.string().nullable().optional(),
    piezometricTubeDiameter: z.number().nullable().optional(),
    piezometricTubeDepth: z.number().nullable().optional(),
  });
};

export type PumpColumnForm = z.infer<ReturnType<typeof getPumpColumnFormSchema>>;